import { cloneDeep, isEqual } from "lodash";
import { useEffect, useRef } from "react";

interface UseOnValueChangedOptions {
  runOnFirstRender?: boolean;
}

const DEFAULT_OPTIONS: UseOnValueChangedOptions = {
  runOnFirstRender: false,
};

const useOnValueChanged = (
  value: any,
  onChanged: (prevValue: any, newValue: any) => void,
  options: UseOnValueChangedOptions = DEFAULT_OPTIONS,
) => {
  const { runOnFirstRender = false } = options;
  const valueRef = useRef(cloneDeep(value));
  const isFirstRenderRef = useRef(true);

  useEffect(() => {
    if (!isEqual(valueRef.current, value)) {
      onChanged(valueRef.current, value);
      valueRef.current = cloneDeep(value);
    }
  });

  useEffect(() => {
    if (runOnFirstRender && isFirstRenderRef.current) {
      isFirstRenderRef.current = false;
      onChanged(valueRef.current, value);
    }
  }, [onChanged, runOnFirstRender, value]);
};

export default useOnValueChanged;
